import { Box, Dialog, DialogContent, DialogContentText, LinearProgress, Typography } from '@mui/material'
import React from 'react'
import { MtLogo } from '../logos'
import { useStyles } from './styles'

const WaitingDialog = ({ open, titleId, title }) => {
  const classes = useStyles()
  return (
    <Dialog fullWidth maxWidth='sm' open={open} aria-labelledby={titleId}>
      <DialogContent>
        <Box display='flex' alignItems='center' flexDirection='column'>
          <MtLogo className={classes.logo} width={236} height={59} />
          <DialogContentText className={classes.title} align='center' gutterBottom variant='body1'>{title}</DialogContentText>
          <Typography className={classes.waitText} align='center' gutterBottom variant='subtitle2'>Please wait...</Typography>
          <LinearProgress className={classes.progress} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default WaitingDialog
